// Banners returned in banners[] from getLandlordStatus response
export const BANNERS = {
  rentalProtectionPolicyEligibleForPayments: 'Notifications/Landlord/PaymentTermEligibleForRentalProtectionPolicy',
};
